import React, { useEffect } from 'react';
import { NotInterestedCont } from './NotInterested.styles';
import OpportunitiesContent from '../../OpportunitiesContent/OpportunitiesContent';
import NotInterestedContent from '../../OpportunitiesContent/NotInterestedContent';
import { useContextSelector } from 'use-context-selector';
import { OpportunitiesContext } from 'pages/Opportunities/context/OpportunitiesContext';

interface Props {
  show: boolean;
}

const NotInterested: React.FC<Props> = ({ show }) => {
  const getNotInterestedOpportunities = useContextSelector(
    OpportunitiesContext,
    (state) => state.getNotInterestedOpportunities,
  );

  useEffect(() => {
    if (show) getNotInterestedOpportunities();
    // console.log('NotInterested Rendered', show);
  }, [show]);

  return (
    <NotInterestedCont style={{ maxHeight: show ? '100%' : 0, padding: 0 }}>
      {/* <OpportunitiesContent jobs={false} /> */}
      <NotInterestedContent />
    </NotInterestedCont>
  );
};

export default React.memo(NotInterested);
